import { render, staticRenderFns } from "./RunnitProviderMappingRow.vue?vue&type=template&id=038de65a&scoped=true"
import script from "./RunnitProviderMappingRow.vue?vue&type=script&lang=ts"
export * from "./RunnitProviderMappingRow.vue?vue&type=script&lang=ts"
import style0 from "./RunnitProviderMappingRow.vue?vue&type=style&index=0&id=038de65a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038de65a",
  null
  
)

export default component.exports